module.exports = __webpack_public_path__ + "static/media/IC_data_management.773aab9c.svg";